import { motion } from 'framer-motion'
import styled from 'styled-components'
import { UnstyledList } from '@velasca/ui/unstyled-list'

export const StorytellingSection = styled.section`
  width: 100%;
`

export const StorytellingItemWrapper = styled.li`
  position: relative;
`

export const StorytellingItemTrigger = styled(motion.button)<{
  isActive: boolean
}>`
  background-color: transparent;
  border: none;
  font-size: 2rem;
  font-family: serif;
  text-transform: capitalize;
  padding-left: 1.5rem;
  color: ${(props) =>
    props.isActive
      ? props.theme.colors.text.primary
      : props.theme.colors.border};
  border-left: 3px solid transparent;
  transition: color 0.3s ease-in-out;
  width: 100%;
  text-align: left;

  &:hover {
    color: ${(props) => props.theme.colors.text.primary};
  }
`

export const AnimatedBorder = styled(motion.div)`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background-color: ${(props) => props.theme.colors.text.primary};
  transform-origin: center;
`

export const TabList = styled(UnstyledList)`
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  min-width: 19rem;
`
